import axios from './index';

// 查询-小视频
export const fetchTheaterList = () => {
  return axios.get('/api/common/homePage/videoSetting/list');
};
